import { Handle, Position, useReactFlow, type Edge } from '@xyflow/react';
import { BaseNode } from '@/components/base-node';
import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const LiveAgentNode = ({ id }: { id: string }) => {
  const { t } = useTranslation();
  const { setNodes, setEdges } = useReactFlow();
  return (
    <BaseNode>
      <Handle type="target" position={Position.Top} />
      <div className="p-4 flex flex-col items-center justify-center">
        <User className="w-8 h-8 mb-2" />
        <p className="font-bold">{t('transferToAgent')}</p>
        <button
          onClick={() => {
            setEdges((eds: Edge[]) => eds.filter((e) => e.source !== id && e.target !== id));
            setNodes((nodes) => nodes.filter((n) => n.id !== id));
          }}
          className="mt-2 text-red-600 px-2 py-1 text-sm border border-red-300 rounded"
        >
          {t('deleteNode')}
        </button>
      </div>
    </BaseNode>
  );
};

export default LiveAgentNode;
